/* eslint-disable @typescript-eslint/no-unused-vars */

'use client'

/* eslint-disable no-unused-vars */

import FabricCanvasTool from '../fabrictool'

import { fabric } from '@/@corefabriccanvas/fabric/dist/fabric'
class Polygon extends FabricCanvasTool {
  configureCanvas(props) {
    const canvas = this._canvas
    canvas.isDrawingMode = canvas.selection = false
    canvas.defaultCursor = 'default'
    canvas.forEachObject((obj) => {
      if (
        !obj.id ||
        (obj.id &&
          !obj.id.includes('pageItem') &&
          !obj.id.includes('gapFillingItem'))
      ) {
        obj.selectable = obj.evented = false
      }
    })
    this._width = props.lineWidth
    this._color = props.lineColor
    this._fill = props.fillColor
  }

  doMouseDown(o) {
    const canvas = this._canvas
    this.isDown = true
    const pointer = canvas.getPointer(o.e)
    this.startX = pointer.x
    this.startY = pointer.y
    this.polygon = new fabric.Polygon(
      [
        {
          x: this.startX,
          y: this.startX
        },
        {
          x: this.startX + 100,
          y: this.startY + 100
        }
      ],
      {
        left: this.startX,
        top: this.startY,
        originX: 'left',
        originY: 'top'
      }
    )
    canvas.add(this.polygon)
  }

  doMouseMove(o) {
    if (!this.isDown) return
    const canvas = this._canvas
    const pointer = canvas.getPointer(o.e)
    if (this.startX > pointer.x) {
      this.polygon.set({ left: Math.abs(pointer.x) })
    }
    if (this.startY > pointer.y) {
      this.polygon.set({ top: Math.abs(pointer.y) })
    }
    this.polygon.set({ width: Math.abs(this.startX - pointer.x) })
    this.polygon.set({ height: Math.abs(this.startY - pointer.y) })
    this.polygon.setCoords()
    canvas.renderAll()
  }

  doMouseUp(o) {
    this.isDown = false
  }
}

export default Polygon
